export default {
  container: {
    '&:not([class*="MuiGrid-grid-"])': {
      width: '100%',
    },
  },
};
